// El estado "vencido" de un envío (el difusor no respondió a tiempo), en
// amarillo, igual para el artista, el difusor y el admin. Ver
// Backend/src/utils/reenvios.js.
export const ESTILO_VENCIDO = { bgcolor: "#FFD54F", color: "#4E3B00" };

// La etiqueta del estado: un vencido que el artista ya reenvió deja de estar
// en amarillo.
export const etiquetaVencido = (reenviado) =>
  reenviado ? "Vencido · Reenviado" : "Vencido";
